export const SET_DATA = 'SET_DATA';
export const SET_VALUE = 'SET_VALUE';
export const SET_ARRAY = 'SET_ARRAY';
export const CLEAR_DATA = 'CLEAR_DATA';
